import React, { MouseEventHandler } from 'react';

import { getIconByName } from '../../../MuiIcon/Icon';
import { DetailWidgetInteractionItem } from '../WidgetElement';
import { sendInteractGATrackEventData } from '../../../../util/gAUtil';
type GenerateIconStyleProps = {
	isHover: boolean;
	clickable: boolean;
	style: {
		textLabel: {
			color: string;
			hoverColor: string;
		};
	};
};
const generateIconStyle = ({ style, clickable, isHover }: GenerateIconStyleProps) => {
	const {
		textLabel: { color, hoverColor },
	} = style;

	return {
		color: !isHover ? color : hoverColor,
		width: '100%',
		height: '100%',
		cursor: clickable ? 'pointer' : 'null',
	};
};

const Icon = ({
	id,
	style,
	data,
	clickable,
	isHover,
	widgetRef,
	onClick,
	handleMouseEnter,
	handleMouseLeave,
	scenarioId,
	sceneId,
}: DetailWidgetInteractionItem) => {
	const {
		coordinate: { x, y },
		dimension: { w = 150, h = 100 },
		rotation,
	} = style;

	const centerPoint = {
		x: x + w - w / 2,
		y: y + h - h / 2,
	};

	const {
		settings: { iconKey = 'AcUnit' },
		name,
		type,
	} = data;

	const handleWidgetAction = (event: React.TouchEvent | React.MouseEvent) => {
		event.stopPropagation();
		sendInteractGATrackEventData(type, name, scenarioId, sceneId);
		onClick(event);
	};

	return (
		<g
			id={id}
			onTouchStart={handleWidgetAction}
			onClick={handleWidgetAction}
			onMouseEnter={handleMouseEnter as MouseEventHandler<SVGGElement>}
			onMouseLeave={handleMouseLeave as MouseEventHandler<SVGGElement>}
		>
			<foreignObject
				ref={widgetRef}
				x={x}
				y={y}
				width={w}
				height={h}
				style={{ transformOrigin: `${centerPoint.x}px ${centerPoint.y}px`, transform: `rotate(${rotation ?? 0}deg)` }}
			>
				<div style={{ width: '100%', height: '100%' }}>
					{getIconByName(iconKey, {
						style: generateIconStyle({ clickable, style, isHover }),
					})}
				</div>
			</foreignObject>
		</g>
	);
};

export default Icon;
